// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"ba4542cd","787":"36b36a7b","850":"ef38dad0"}[chunkId] + ".chunk.js";
};